<template>
<div class="pagewide partnerinfo mtpage">

	<topheader back="/panel">
		<template v-slot:info>
			<span>{{$t('plans.partnerinfo')}}</span>
		</template>
		<template v-slot:right>
			
		</template>

	</topheader>

	<maincontent>
		<template v-slot:content>
            <partnerinfo />
		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>
	

</style>

<script>



export default {
	name: 'panel_partnerinfo_page',
	components: {
		partnerinfo : () => import("@/components/modules/panel/partnerinfo/index.vue")
	},

	data : function(){
		return { 
		}
	},

	computed: {

	},

	methods: {
		
	},

	mounted() {

	}
}
</script>
